import Button from "components/common/buttons/buttons";
import moment from "moment-timezone";
import { TYPO } from "styles/Typo";
import { useStockNewsRader } from "utils/clientAPIs/newsRader";
import DetailAINewsRaderAlarmCTA from "./AlarmCTA";
import { AlarmProvider } from "../../Header/Buttons/Index";
import { useRouter } from "next/router";

// url 에서 핵심 도메인(첫 레이블) 추출: TLD 제거 + www 필터링
const getCoreDomain = (url: string) => {
  try {
    const hostname = new URL(url).hostname; // e.g., aaa.bbbbb.ccc
    const segments = hostname.split(".").filter(Boolean);
    if (segments.length === 0) return hostname;

    // 1) TLD 제거 (마지막 세그먼트)
    segments.pop();

    // 2) 선두가 www 이면 제거
    if (segments[0]?.toLowerCase() === "www") segments.shift();

    // 3) 남은 첫 세그먼트 반환 (없으면 빈 문자열)
    return segments.join(".");
  } catch (e) {
    return "";
  }
};

function DetailAINewsRader({ detailData }: { detailData: any }) {
  const router = useRouter();
  const { data, isLoading, isError } = useStockNewsRader(detailData?.ITEM_CD);
  const keywords = data?.KEYWORD?.split(",");
  if (isLoading) return <div></div>;
  if (isError) return <div></div>;
  if (data?.length === 0)
    return (
      <AlarmProvider detailData={detailData}>
        {(props) => <DetailAINewsRaderAlarmCTA {...props} />}
      </AlarmProvider>
    );
  return (
    <div className="px-6 py-5">
      <div className="">
        {data?.map((item: any, index: number) => (
          <div key={index} data-testid="new-leader-detail-list">
            <div className="flex items-stretch ">
              <div className="w-[48px] flex flex-col gap-2 shrink-0 items-end">
                <p
                  className={`text-gray60 ${TYPO.TYPO8_RG} whitespace-nowrap`}
                  data-testid="new-leader-detail-date"
                >
                  {router.locale === "ko"
                    ? moment(item.BASE_DT).format("M월 D일")
                    : moment(item.BASE_DT).format("MMM D")}
                </p>
              </div>
              <div className="px-4">
                <div className="h-full w-[1px] bg-hairline" />
              </div>
              <div className="flex flex-col gap-2 pb-[30px] w-full overflow-hidden">
                <div className="flex items-center gap-1">
                  <p
                    className={`text-gray80 ${TYPO.TYPO7_1_MD} text-right whitespace-pre-wrap break-all`}
                    data-testid="new-leader-detail-price"
                  >
                    {item.CURR === "KRW" ? "" : "$"}
                    {item?.ADJ_CLOSE?.toLocaleString("en-US", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 1,
                    })}
                    {item?.CURR === "KRW" ? "원" : ""}
                  </p>
                  <p
                    className={`${TYPO.TYPO8_RG} ${
                      Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) === 0
                        ? "text-gray70"
                        : item?.ADJ_CLOSE_CHG > 0
                        ? "text-red40"
                        : "text-blue40"
                    }`}
                    data-testid="new-leader-detail-change"
                  >
                    {Number(item?.ADJ_CLOSE_CHG?.toFixed(1)) > 0 ? "+" : ""}
                    {item?.ADJ_CLOSE_CHG?.toFixed(1)}%
                  </p>
                </div>
                <div className="w-full flex flex-col gap-[5px]">
                  <div className="flex gap-1 items-center flex-wrap">
                    {item?.KEYWORD?.split(",")?.map(
                      (keyword: string, index: number) => (
                        <p
                          key={index}
                          className={`bg-gray10 rounded-[6px] px-1 ${TYPO.TYPO7_1_MD} text-gray80 whitespace-nowrap`}
                          data-testid="new-leader-detail-keyword"
                        >
                          {keyword}
                        </p>
                      )
                    )}
                  </div>
                  <p
                    className={`text-[14px] font-[400] font-['pretendard'] leading-[26.25px] tracking-[-0.2px] text-gray70 custom-word-break  `}
                  >
                    {item.DESCRIPTION}
                    {item?.URL && (
                      <a
                        className="ml-1 bg-gray10 rounded-[4px] px-1 py-[2px] text-[10px] font-[400] text-gray70 leading-[12px] cursor-pointer "
                        href={item.URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getCoreDomain(item?.URL || "")}
                      </a>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DetailAINewsRader;
